<!--
 * @Author: 曹捷
 * @Date: 2022-01-10 10:02:05
 * @LastEditors: 曹捷
 * @LastEditTime: 2022-01-10 10:36:50
 * @Description: 设备故障
-->
<template>
  <div class="charts" ref="chartContainer"></div>
</template>

<script>
import { onMounted, toRefs, reactive } from 'vue'
import dayjs from 'dayjs'
export default {
  setup () {
    let _data = reactive({
      chartContainer: null
    })
    let _methods = {
      initChart () {
        const { Pie } = G2Plot;
        let data = [
          { type: '故障', value: 12 },
          { type: '运行中', value: 983 },
        ]
        const piePlot = new Pie(_data.chartContainer, {
          appendPadding: 20,
          data,
          angleField: 'value',
          colorField: 'type',
          radius: 1,
          innerRadius: 0.75,
          legend: false,
          label: {
            content: '',
          },
          interactions: [{ type: 'element-selected' }, { type: 'element-active' }],
          statistic: {
            title: {
              content: '设备故障对比',
              style: {
                fontSize: 14
              }
            },
            content: {
              style: {
                color: '#FF9800',
                whiteSpace: 'pre-wrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                fontSize: 48

              },
              formatter (info) {
                return `${Math.ceil(data[0].value / (data[0].value + data[1].value) * 100)}%`
              },
            },
          },
          color: ['#FF9800', '#BDBDBD'],
        });
        piePlot.render();
      }
    }
    onMounted(() => {
      _methods.initChart()
    })
    return {
      ...toRefs(_data),
      ..._methods
    }
  }
}
</script>

<style lang="less">
.charts {
  width: 100%;
  height: 100%;
}
</style>